import { useEffect, useRef, useState } from "react";
import "../styles/calendar.css";
import "../styles/tooltip.css";

import { AiFillInfoCircle } from "react-icons/ai";

import { t } from "../../translations";
import { Aa } from "../functions/Aa";
import { getNext20Days } from "../functions/dateFunctions";

import { createLogger } from "../../utils/logger";

const logger = createLogger("Calendar");

const Calendar = (props) => {
  const [index, setIndex] = useState(0);
  const [arrDays, setArrDays] = useState([]);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");

  const listRef = useRef([]);

  const { lang } = props;

  useEffect(() => {
    calculateCurrentMonthAndSetDays();

    if (listRef.current[parseInt(day)]) {
      listRef.current[parseInt(day)].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
      });
    }
  }, [day, props?.allowToday]);

  const calculateCurrentMonthAndSetDays = async () => {
    const today = new Date();

    let year = today.getFullYear();

    let month = today.getMonth() + 1;
    let day = today.getDate();

    month = month < 10 ? `0${month}` : month;

    day = day < 10 ? `0${day}` : day;

    setYear(year);
    setMonth(month);
    setDay(day);

    setIndex(month - 1);
    const next20days = await getNext20Days(props?.allowToday || false);
    setArrDays(next20days);
  };

  return (
    <div className="calendar-bar">
      <div className="calendar-block">
        <p
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5
          }}
        >
          {props?.title}
          <span
            className="tooltip-container"
            style={{
              color: "#838383",
              display: "flex",
              alignItems: "center",
              gap: 5,
              cursor: "help"
            }}
          >
            {" "}
            {t(`common.why_question`, lang)}
            <AiFillInfoCircle size={20} />
            <div className="tooltip-popup">
              {t(`common.why_question_tooltip`, lang)}
              <div className="tooltip-arrow" />
            </div>
          </span>
        </p>
        <div className="calendar-box">
          <div className="calendar-days" style={{}}>
            {arrDays.map((item, count) => (
              <div
                key={item?.dayLong}
                className="btn-days-calendar"
                ref={(el) => (listRef.current[count] = el)}
                style={{
                  border:
                    props?.selectedDate === item?.dayLong
                      ? "none"
                      : "1px solid #dedede",
                  color:
                    props?.selectedDate === item?.dayLong ? "#fff" : "#040404",
                  backgroundColor:
                    props?.selectedDate === item?.dayLong ? "#FF114D" : "#fff"
                }}
                onClick={() => {
                  props?.setDay(item?.dayLong);

                  listRef.current[count].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                  });
                }}
              >
                <span
                  style={{
                    fontWeight: "600"
                  }}
                >
                  {Aa(
                    props?.lang === "en"
                      ? item?.dayTextEnglish
                      : item?.dayTextFrench
                  )}
                </span>

                <span
                  style={{
                    fontSize: 14,
                    fontWeight: "400"
                  }}
                >
                  {Aa(
                    props?.lang === "en"
                      ? item?.monthTextEnglish
                      : item?.monthTextFrench
                  )}{" "}
                  {item?.day}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
